$(function(){
    $("#form-forgot").validate({       
        rules: {
            Id:{
                required: true,
                minlength : 9,
                maxlength: 30
            }          
        },
        submitHandler: recovery
    });
});


function recovery(){
    $('#btn-reset-password').prop('disabled',true);
    $.ajax({
        url: '/Register/SendResetToken',
        data: {Id : $('#Id').val()},
        datatype:'JSON',
        type:'POST',
        success: function(resposne){
            Swal.fire({
                icon: 'success',
                title: 'Restablecer Contraseña',
                text: 'Por favor verifica tu correo electrónico para restablecer la contraseña',
                confirmButtonColor: "#001f3f",
            });
        },
        error: function(ex){
            console.error(ex);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al procesar su transacción',
                confirmButtonColor: "#001f3f",
            });
        }
    })
}